import { render, staticRenderFns } from "./salesOrderDetails.vue?vue&type=template&id=d943d3f4&scoped=true"
import script from "./salesOrderDetails.vue?vue&type=script&lang=js"
export * from "./salesOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./salesOrderDetails.vue?vue&type=style&index=0&id=d943d3f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d943d3f4",
  null
  
)

export default component.exports